import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Card, CardBody, CardGroup, Col,
  Container, Row,
} from 'reactstrap';
import { axiosGet } from '../../../../helper/fetch';
import logHandling from '../../../../helper/logHandling';
import { loginImpersonateAsync } from '../../../../redux/services/authServices';
import { getProfile } from '../../../../redux/actions/actions';
import { setTokenOnly } from '../../../../services/LocalStorageService';
import Loading from '../../../Component/Loading';

const ImpersonateScreen = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [usersList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const { userinfo } = useSelector((store) => store.user);
  const [loginAsUser, setLoginAsUser] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    // Para cancelar la llamada al servidor!!
    const abortController = new AbortController();
    // Obtengo los datos del usuario logueado. Se podria solo pasar como parametro el username desde el login y listo o usar el hook use login!
    dispatch(getProfile());
    (async () => {
      try {
        await loadUsersImpersonate();
      } catch (err) {
        logHandling(err);
        setLoading(false);
        setHasError(true);
      }
    })();
    // Si cierro el componente antes de que llegue la respuesta o algo asi
    return () => {
      abortController.abort();
    };
  }, []);

  // Un useeffect para escuchar cuando cambia el valor de userinfo
  useEffect(() => {
    if (userinfo.userinfo) {
      const unserName = userinfo.userinfo.username || 'NN';
      setLoginAsUser(unserName);
    }
  }, [userinfo]);

  // Un useeffect para escuchar cuando hay un error y cambiarlo de pantalla!
  useEffect(() => {
    if (hasError) {
      history.push('/');
    }
  }, [hasError]);

  // Add to the component state the result of "loadUsersImpersonate"
  const setUsersImpersonate = (data) => {
    setUsersList([
      ...usersList,
      ...data,
    ]);
    // Aqui actualiza la pantalla y cambia de login a la lista,
    // Esto impacta en los test Cases.
    setLoading(false);
  };

  // Get all usesrs that can login to web admin
  // Todo add a paginator
  const loadUsersImpersonate = async () => {
    try {
      const { data } = await axiosGet('api/user/impersonate/all', 'GET');
      const dataFullMapped = data.map((user) => ({
        id: user.userId,
        userName: user.username,
      }));
      // Set data in state
      setUsersImpersonate(dataFullMapped);
    } catch (err) {
      logHandling(err);
    }
  };

  // To go to dashboard as selected user
  const handleNextClick = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (userinfo.userName !== loginAsUser) {
        const data = await loginImpersonateAsync(loginAsUser);
        setTokenOnly(data.token);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      logHandling(err);
    }
    history.push('/');
  };

  // Managed the selected value from users`s <select></select>
  const handleSelect = (e) => {
    setLoginAsUser(e.target.value);
  };

  return (
    <>
      { loading ? (<Loading loading />) : (
        <div className="d-flex align-items-center justify-content-center vh-100">
          <Container>
            <Row className="justify-content-center">
              <Col md="6">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody className="d-flex flex-column ">
                      <h3 className="Impersonate__Screen__title__h3 animate__animated animate__fadeInUp col-xs-12 mb-4">{t('Impersonate.impersonate')} </h3>
                      <p className="Impersonate__Screen animate__animated animate__fadeInUp col-xs-12">{t('Impersonate.selet-profile')} </p>
                      <select
                        className="custom-select  animate__animated animate__fadeInUp"
                        aria-label="form-select-lg"
                        onChange={handleSelect}
                        value={loginAsUser}
                      >
                        {usersList.map((user, i) => (
                          <option
                            key={i}
                            value={user.userName}
                          >{user.userName}
                          </option>
                        ))}
                      </select>
                      <div className="text-center">
                        <button
                          className="mt-4 btn btn-success animate__animated animate__fadeInUp "
                          type="submit"
                          onClick={handleNextClick}
                        >
                          {t('Impersonate.next')}
                        </button>
                      </div>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      )};
    </>

  );
};

export default ImpersonateScreen;
